module.exports = __webpack_public_path__ + "static/media/SallyTail.e3cd5b79.png";